'use client';
import React from 'react';

const logos = [
  { name: 'Tekmetric', sub: 'Shop Management' },
  { name: 'Shop-Ware', sub: 'Cloud DMS' },
  { name: 'Mitchell 1', sub: 'Repair Info' },
  { name: 'QuickBooks', sub: 'Accounting' },
  { name: 'RepairPal', sub: 'Estimating' },
  { name: 'MOTOR', sub: 'Labor Guide' },
  { name: 'Identifix', sub: 'Diagnostics' },
  { name: 'Worldpac', sub: 'Parts' },
];

const LogoCard: React.FC<{ name: string; sub: string }> = ({ name, sub }) => (
  <div className="glass-panel flex-shrink-0 mx-3 px-6 py-3.5 flex flex-col items-center justify-center min-w-[140px]">
    <span className="font-heading font-700 text-[15px] text-[#C0C7D0] tracking-tight whitespace-nowrap">{name}</span>
    <span className="text-[10px] text-[rgba(192,199,208,0.45)] tracking-widest uppercase mt-0.5">{sub}</span>
  </div>
);

const LogoRibbon: React.FC = () => {
  const doubled = [...logos, ...logos];

  return (
    <section id="integrations" className="py-14 overflow-hidden border-y border-[rgba(255,255,255,0.06)]">
      <div className="max-w-7xl mx-auto px-6 mb-6">
        <p className="text-[11px] tracking-[0.35em] uppercase text-[rgba(192,199,208,0.4)] font-medium text-center">
          Syncs with the tools already running your shop
        </p>
      </div>
      <div className="relative overflow-hidden">
        <div className="logo-scroll-track">
          {doubled.map((logo, i) => (
            <LogoCard key={i} name={logo.name} sub={logo.sub} />
          ))}
        </div>
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#0D0D0D] to-transparent pointer-events-none z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#0D0D0D] to-transparent pointer-events-none z-10" />
      </div>
    </section>
  );
};

export default LogoRibbon;